<svg
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	stroke-width="1.5"
	fill="none"
	stroke="currentColor"
	xmlns="http://www.w3.org/2000/svg"
	color="currentColor"
>
	<title>High volume</title>
	<path
		d="M1 13.8571V10.1429C1 9.03829 1.89543 8.14286 3 8.14286H5.9C6.09569 8.14286 6.28708 8.08544 6.45046 7.97772L12.4495 4.02228C13.1144 3.5839 14 4.06075 14 4.85714V19.1429C14 19.9392 13.1144 20.4161 12.4495 19.9777L6.45046 16.0223C6.28708 15.9146 6.09569 15.8571 5.9 15.8571H3C1.89543 15.8571 1 14.9617 1 13.8571Z"
		stroke-width="1.5"
	/><path
		d="M17.5 7.5C17.5 7.5 19 9 19 11.5C19 14 17.5 15.5 17.5 15.5"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/><path
		d="M20.5 4.5C20.5 4.5 23 7 23 11.5C23 16 20.5 18.5 20.5 18.5"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/></svg
>
